import Vue from 'vue'

Vue.filter('secondsToMinutes', value => {
  const seconds = Number(value) || 0
  const minutes = Math.round(seconds / 60)
  return minutes + ' min'
})
